import Footer from "../navigation/footerContainer";
import Header from "../navigation/headerContainer";
import UpdatePasswordForm from "./updatePasswordForm";

export default function UpdatePasswordPage(){

    return(
        <>
            <Header />
            <UpdatePasswordForm />
            <Footer />
        
        </>
    )
}